import React from 'react';
import Footer from '../../../components/Footer/Footer';
import AppHeader from '../../../components/Header/AppHeader';
import { Link } from "react-router-dom";
import './AboutUs.scss'
function AboutJSSAHER() {
	return (
		<div>
			<AppHeader />

			<div align="left" style={{ padding: "5% 5% 10% 5%" }}>
				<Link to={`/`} >
					<p style={{color: "#01498e",marginTop:"10px", fontSize: "small" }}>{`< Back To Home`}</p>
				</Link>
				<p className="headingStyle" >About JSSAHER</p>
				<p className="subHeading"
				>
					The Journey of Quality and Excellence of
					JSS Academy of Higher Education & Research
				</p>
				<p className="contentAboutUs">JSS Academy of
				Higher Education & Research, Mysuru since its establishment has significantly strengthened its
				teaching, research and service efforts to realize its vision and mission.

					<br /> <br />
					Under the leadership and gracious Patronage and Blessings of His Holiness Jagadguru Sri Shivarathri
					Deshikendra Mahaswamiji, the Chancellor of JSS Academy of Higher Education & Research, the guidance
					from a highly distinguished Board of Management, and the stewardship of the Vice Chancellor,
					Dr.B.Suresh, a noted multifaceted leader of repute, JSS Academy of Higher Education & Research,
					Mysuru has made great progress in grooming graduates, postgraduates, and Ph.D researchers by
					providing effective value based education across the institutions by focusing on overall development
					of an individual through state-of-art facilities to make the learner a useful citizen to the
					society.
					<br /> <br />

					JSS Academy of Higher Education & Research, Mysuru is a Health Science focused Higher Education
					Institution and comprises of Faculties of Medicine, Biomedical Sciences, Pharmacy, Dentistry, Life
					Sciences and Management Studies. It has, as its constituent colleges the JSS Medical College, the
					JSS Dental College& Hospital and the JSS College of Pharmacy at its main campus at Mysuru and the
					JSS College of Pharmacy at Ootacamund, Tamil Nadu (off-campus). Besides the four constituent
					colleges, the deemed university has established two departments, namely the Department of Water and
					Health and the Department of Health System Management Studies.

					<br /> <br />
					JSS Academy of Higher Education & Research, Mysuru has been ranked among the top 50
					universities/Higher Education Institutions in India continuously for the last four years by NIRF-
					National Institutional Ranking Framework and was also ranked 4th among Private Higher Education
					Institutions by ARIIA Ranking-Atal Ranking of Institutions on Innovation Achievements , initiative
					by MHRD, Government of India and re-accredited by National Assessment and Accreditation Council
					(NAAC) with A+ Grade (CGPA of 3.47 out of 4) in 2018. It has also been granted Category 1 status by
					UGC for having maintained higher standards of Excellence.
					<br /><br />
					JSS Academy of Higher Education & Research, Mysuru is ranked in the 251-300 band globally and first
					nationally in the subject category of Clinical, Preclinical and Health, which includes Medicine,
					Dentistry, Pharmacy and Allied Health Sciences and also made a mark among top 500 Universities
					globally with rank band 401-500 and among the top 5 Higher Education Institutions nationally and
					ranked third in India and ranked 64th in the ranking of higher education institutions amongst
					emerging economies by Times Higher Education (THE) Rankings. JSS Academy of Higher Education &
					Research was also ranked among top 200 in Times Higher Education world University Impact Ranking
					2019 with a rank band 101- 200 and ranked 1st in India, The Impact Ranking assess universities
					against the United Nations' Sustainable Development Goals. THE Asia university ranking 2019 is 62nd.

				</p>
				<p className="contentAboutUs" >
					QS-Quacquarelli Symonds Ranking agency rated JSSAHER with 4 stars in Excellence and became the first
					Health Science institution nationally to be awarded with 4 stars.
				</p>
				<p className="contentAboutUs">
					'Quality' and 'Excellence' have been the key drivers of the JSSAHER which is evident from the
					various strides it has made in the benchmarking initiatives nationally and internationally in a
					short span of ten years. The good governance structure and extraordinary leadership of the
					institution has played a catalyst's role for it to progress quickly and continue its journey to the
					next level of advancement. The committed faculty, the diverse student community, the strategic
					national and international co-operations and infusion of right amount of resources on right projects
					have added value towards its success journey. The integration of medical sciences with the life
					sciences and the allied health sciences has brought in a culture of inter professional education and
					research which has added uniqueness to the education and research environment of the institution.
				</p><br></br>

				<p className="subHeading">
					2019 Ranking of JSS Academy of Higher Education & Research
				</p>
				<p className="subHeading_vertical"
				>
					<strong className="sideHedaing">I. NIRF RANKING 2019 :</strong></p><br />
				<p className="contentAboutUs">Honourable President of
				India, Shri.Ram Nath Kovind announced the National Institutional Ranking Framework (NIRF) India
				Rankings 2019 on April 8, 2019. The rankings were announced under nine categories - Overall,
				Universities, Engineering, Colleges, Management, Pharmacy, Medical, Architecture, and Law.
				</p>
				<br />
				<p className="contentAboutUs">
					<strong> JSS Academy of Higher Education & Research, Mysuru and its constituents colleges had been
					participating in NIRF ranking for the last 4 years and sustaining its position under top 50
						Universities/ Higher Education Institutions in India.</strong>
				</p>
				<ol className="contentAboutUs" style={{ padding: "0px 0px 0px 20px" }}>
					<li>JSSAcademy of Higher Education &Research, Mysuru was ranked 34th out of 1479 University and 55th
					out of 4867 over all Institutions in India, registered for NIRF 2019.
						<br />
						JSS Academy of Higher Education & Research moved up in ranking from 2018 ,which was at the 37
						for University & 59 for overall ranking.
					</li>
					<li>JSS Medical Colleges was ranked 17th out of 113 Medical Institutions/colleges in India.</li>
					<li>JSS College of Pharmacy, Ooty was ranked 8th out of 301 Pharmacy Colleges in India, which was at
						15th rank in 2018.</li>
					<li>JSS College of Pharmacy, Mysore was ranked 10th out of 301 Pharmacy Colleges in India and
						sustaining its position for the last four years at 10th Rank.</li>
				</ol><br />
				<p
					className="subHeading_vertical">
					<strong className="sideHedaing">II. ARIIA RANKING- ATAL RANKING OF INSTITUTIONS ON INNOVATION ACHIEVEMENTS 2019:</strong>
				</p>
				<br />
				<p className="contentAboutUs"><strong>JSS Academy of Higher Education
						& Research is ranked 4th among all the Private Higher Education Institution in India.</strong>
				</p>
				<p className="contentAboutUs">Atal Ranking of Institutions on
				Innovation Achievements (ARIIA) is an initiative of Ministry of Human Resource Development (MHRD),
				Govt. of India to systematically rank higher educational institutions and universities in India on
				indicators related to "Innovation and Entrepreneurship Development" amongst students and faculties.
				Assessment of innovation and start-up ecosystem was based on Budget, Expenses to Support, Facilities
				to Support Innovations and Start-ups, Awareness Activities for Promoting Innovation,
				Entrepreneurship Development, Intellectual Property Generation, Technology Transfer and
					Commercialization ,Innovative Learning & Innovations in Governance of the Institution.</p>
				<br />
				<div>
					<p
						className="subHeading" style={{ fontSize: "19px" }}>
						2019 Ranking of JSS Academy of Higher Education & Research <br />
						Vision and Mission of JSS Academy of Higher Education & Research :</p>
					<div style={{ float: "left", width: "48%", border: "1px solid aliceblue" }}>
						<p
							style={{ textAlign: "left", fontWeight: "bold", fontFamily: "MyWebFont1", color: "#000", padding: "10px 10px", margin: "0", backgroundColor: "#E77C2D" }}>
							VISION
							<br /></p>
						<p className="contentAboutUs" style={{ padding: "5px" }}>
							<strong>To provide education that helps transformation of individuals and society.</strong>

						</p>
					</div>

				</div>
				<div style={{ float: "right", width: "50%", border: "1px solid aliceblue" }}>
					<p
						style={{ textAlign: "left", fontWeight: "bold", fontFamily: "MyWebFont1", color: "#000", padding: "10px 10px", margin: "0", backgroundColor: "#E77C2D", color: "white" }}>
						MISSION</p>
					<p className="contentAboutUs" style={{ padding: "5px" }}>
						<strong>To expand the boundaries of education and to make the most amazing learning possible
								by:</strong><br /><br />
						<ul
							style={{ textAlign: "left", fontFamily: "Helvetica,Helvetica Neue", color: "#000", margin: "-4px", fontSize: "16px" }}>
							<li>Providing superior undergraduate, graduate and professional education to it's
									students.</li>
							<li>Developing and advancing the talents of students to create applicable knowledge.
								</li>
							<li>Nurturing translational and transformational research that benefit the society.</li>
							<li>Inspiring to excel in health sciences delivery and care.</li>
						</ul>

					</p>
				</div>


			</div>

			<Footer />
		</div>
	)
}
export default AboutJSSAHER;